var CHART_HEIGHT = 350;

module.exports = {
	cleanData: function (data) {
		for (var i = 0; i < data.length; i++) {
			var dp = data[i];
			for (var x in dp) {
				if (dp.hasOwnProperty(x) && dp[x] === 'NaN' || dp[x] === '') {
					dp[x] = null;
				}
			}
		}
		return data;
	},
	setChartHeight: function (chart, chartType) {
		chart.events.on('datavalidated',
			function (ev) {
				var chart = ev.target;
				var legendHeight = chart.legend && chart.legend.contentHeight;
				var height = CHART_HEIGHT + legendHeight;
				if (chartType === 'BarHorizontal') {
					var numOfColumns = chart.series.values[0].endIndex;
					chart.svgContainer.htmlElement.style.height = height + 16 * numOfColumns + 'px';
				} else {
					chart.svgContainer.htmlElement.style.height = height + 'px';
				}
			});
	},
	setValueAxisMinimum: function (chart, valueAxis) {
		chart.events.on('datavalidated',
			function () {
				if (valueAxis.min >= 0 || valueAxis.min  === undefined) {
					valueAxis.min = 0;
				}
			});
	},
	setNumberFormat: function (chart, showDecimals, numberOfDecimals) {
		if (showDecimals.toLowerCase() === 'true') {
			var zeroes = '0'.repeat(numberOfDecimals || 2);
			chart.numberFormatter.numberFormat = '#,###.' + zeroes;
		} else {
			chart.numberFormatter.numberFormat = '#,###.';
		}
	}
};
